import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines clsx + tailwind-merge for conditional class names.
 * Used in .tsx files ONLY to merge className from props.
 * All static styles go in .styles.ts files.
 */
const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export { cn };
